import React from 'react';
import Modal from '../../components/comm/Modal';
const AlertBox = ({ isOpen, onClose, message = "", btnTxt, callback, subMessage }) => {
    if (!isOpen) return null;

    const handleClicBtn = () => {
        if(callback) callback();

        onClose();
    }

    return (
        <Modal isOpen={isOpen} >
            <div className='modal-box' data-type="a">
                <div className='modal-top-box'>
                    <div className='title-box'>
                       {message.split('\n').map((line, idx) => (
                           <p key={idx}>{line}</p>
                       ))}
                       {subMessage?.split('\n').map((line, idx) => (
                           <span key={idx}>{line}</span>
                       ))}
                    </div>
                </div>

                <div className="modal-bottom-box">
                    <div className='btn-layout'>
                        <button className="btn" data-btn-type="fill-main" data-btn-size="md"
                                onClick={handleClicBtn}>
                            <span>{btnTxt}</span>
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
)
}

export default AlertBox;
